import { makeAuthService } from '../../auth/auth-service-factory';
import { makeLogService } from '../../common/log/log/log-service-factory';
import { PriorityServiceImpl } from './priority-service-impl';

export function makePriorityService() {
  return new PriorityServiceImpl(makeLogService(), makeAuthService());
}
